import { generateTheme } from "@catchoftheday/theme";
var headerTheme = generateTheme(false);
headerTheme.maxWidths = {
  "default": "1320px"
};
export default headerTheme;